import { useEffect, useState } from 'react';
import { NumberFormatter } from '@mantine/core';

import { useApi } from 'libs/data-access';
import { IGstList } from 'libs/data-access/types';

import { ListItem } from './ListItem';

interface IProps {
    service: "FLIGHT" | "HOTEL";
    totalFare: number;
    refundCharges: {
        bookingId: number;
        supplierCharge: number | null;
        cancellationCharge: number | null;
        cancellationChargeGst: number | null;
    }[];
    usedBy?: "CREDIT_NOTE" | "PRICING";
};

export function RefundFeeSummary({
    service,
    totalFare,
    refundCharges,
    usedBy = "PRICING"
}: IProps) {

    // const { postData } = useApi();


    useEffect(() => {
        calculateFareBreakup();
    }, [totalFare]);


    const [fareBreakup, setFareBreakup] = useState<{
        supplierCharge: number;
        cancellationCharge: number;
        gst: number;
        totalChargableAmount: number;
        totalRefundableAmount: number;
    }>({
        supplierCharge: 0,
        cancellationCharge: 0,
        gst: 0,
        totalChargableAmount: 0,
        totalRefundableAmount: 0,
    });


    // HANDLER FUNCTIONS
    const calculateFareBreakup = () => {
        const providerCharge = refundCharges.reduce((acc, curr) => acc += (curr.supplierCharge || 0), 0);
        const myCharge = refundCharges.reduce((acc, curr) => acc += (curr.cancellationCharge || 0), 0);
        const myChargeGST = refundCharges.reduce((acc, curr) => acc += (curr.cancellationChargeGst || 0), 0);

        console.log("totalFare: ", totalFare);
        console.log("refundCharges: ", refundCharges);
        console.log("providerCharge: ", providerCharge);
        console.log("myCharge: ", myCharge);
        console.log("myChargeGST: ", myChargeGST);
        console.log("totalChargableAmount: ", providerCharge + myCharge + myChargeGST);

        setFareBreakup(prev => ({
            ...prev,
            gst: Number(myChargeGST.toFixed(2)),
            supplierCharge: providerCharge,
            cancellationCharge: myCharge,
            totalChargableAmount: providerCharge + myCharge + myChargeGST,
            totalRefundableAmount: totalFare - (providerCharge + myCharge + myChargeGST)
        }));
    };


    return (
        <>
            {
                usedBy === "PRICING"
                    ?
                    <div className="flex flex-col gap-2">
                        {/* Supplier Charge: charge applied by supplier for cancellation */}
                        <ListItem
                            title={`(-)CANCELLATION CHARGE (${service})`}
                            value={fareBreakup.supplierCharge}
                        />

                        {/* My Cancellation Charge: charge applied by admin for cancellation */}
                        <ListItem
                            title={`(-)CANCELLATION SERV.CHARG (${service} TKT)`}
                            value={fareBreakup.cancellationCharge}
                        />

                        {/* GST: charge applied on My Cancellation */}
                        <ListItem
                            title="GST (All Inclusive)"
                            value={fareBreakup.gst}
                        />

                        {/* total */}
                        <div className=" bg-gray-100 py-1 px-2 rounded-md font-semibold text-lg">
                            <ListItem
                                title="Total Deduction"
                                showPrefix={true}
                                value={Number(fareBreakup.totalChargableAmount.toFixed(2))}
                            />
                        </div>
                    </div>
                    :
                    <div className="w-full border border-gray-300 rounded-md p-3">
                        <h3 className="text-sm font-semibold text-gray-800 mb-3 pb-2 border-b border-gray-300">
                            Refund Summary
                        </h3>

                        <div className="space-y-2">
                            <div className="flex justify-between">
                                <p className="text-sm text-gray-600">(-)CANCELLATION CHARGE ({service})</p>
                                <p className="text-sm font-medium text-gray-800">
                                    <NumberFormatter
                                        thousandSeparator
                                        prefix={"₹"}
                                        value={fareBreakup.supplierCharge}
                                    />
                                </p>
                            </div>
                            <div className="flex justify-between">
                                <p className="text-sm text-gray-600">(-)CANCELLATION SERV.CHARG ({service} TKT)</p>
                                <p className="text-sm font-medium text-gray-800">
                                    <NumberFormatter
                                        thousandSeparator
                                        prefix={"₹"}
                                        value={fareBreakup.cancellationCharge}
                                    />
                                </p>
                            </div>
                            <div className="flex justify-between">
                                <p className="text-sm text-gray-600">GST (All Inclusive)</p>
                                <p className="text-sm font-medium text-gray-800">
                                    <NumberFormatter
                                        thousandSeparator
                                        prefix={"₹"}
                                        value={fareBreakup.gst}
                                    />
                                </p>
                            </div>
                            <div className="flex justify-between font-bold text-gray-800 pt-2 mt-2 border-t border-gray-300">
                                <p>Total Deduction</p>
                                <NumberFormatter
                                    thousandSeparator
                                    prefix={"₹"}
                                    value={Number(fareBreakup.totalChargableAmount.toFixed(2))}
                                />
                            </div>
                        </div>
                    </div>
            }
        </>
    )
}